<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="resetForm"
    :width="900"
  >
    <a-form ref="formRef" :model="formState" :rules="rules">
      <div class="df both-side">
        <a-form-item label="年度" name="year">
          <a-input-number
            v-model:value="formState.year"
            style="width: 300px"
            :disabled="!isEditable"
          />
        </a-form-item>
        <a-form-item label="设备类型" name="serialType">
          <a-cascader
            v-model:value="selectSerial"
            :options="options"
            @change="handleSerialChange"
            placeholder="请选择设备类型"
            style="width: 360px"
            :disabled="!isEditable"
          />
        </a-form-item>
      </div>

      <div class="df both-side">
        <a-form-item label="机身号" name="serial">
          <a-input
            v-model:value="formState.serial"
            style="width: 300px"
            :disabled="!isEditable"
          ></a-input>
        </a-form-item>
        <a-form-item label="对接人" name="contactPerson">
          <a-input
            v-model:value="formState.contactPerson"
            style="width: 360px"
            :disabled="!isEditable"
          />
        </a-form-item>
      </div>

      <div class="df both-side">
        <a-form-item label="返厂地址" name="returnAddress">
          <a-select
            v-model:value="formState.returnAddress"
            placeholder="请选择返厂地址"
            style="width: 300px"
          >
            <a-select-option value="广州">广州</a-select-option>
            <a-select-option value="长沙">长沙</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="备注" name="notes">
          <a-textarea
            v-model:value="formState.notes"
            style="width: 360px"
            :disabled="!isEditable"
            auto-size
          />
        </a-form-item>
      </div>

      <a-form-item
        label="客户信息"
        name="repairCustomerInfo"
        v-if="customInfoAuthority"
      >
        <a-textarea
          v-model:value="formState.repairCustomerInfo"
          style="width: 300px"
          :disabled="!isEditable"
          auto-size
        />
      </a-form-item>
      <a-form-item label="售后问题" name="afterSaleProblemDescription">
        <after-sale-qeustion-vue
          :questionLists="formState.afterSaleProblemDescription"
          ref="questionRef"
        ></after-sale-qeustion-vue>
      </a-form-item>
      <a-form-item label="返回配件" name="accessory">
        <accessory
          v-if="selectSerial.length === 2"
          :machine="formState.serialType"
          :accessoryList="accessoryList"
          ref="accessoryRef"
          :disabled="!isEditable"
        ></accessory>
      </a-form-item>

      <a-form-item label="图片" v-if="modalConfig.visible">
        <upload-img-vue
          :attachment="formState.picture"
          :disabled="!isEditable"
          ref="uploadImg"
        ></upload-img-vue>
      </a-form-item>
      <a-form-item label="视频" v-if="modalConfig.visible">
        <upload-video-vue
          :attachment="formState.video"
          :disabled="!isEditable"
          ref="uploadVideo"
        ></upload-video-vue>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
} from "vue";
import {
  saveOrUpdateRepairEquipment,
  updateSwanAccessory,
  updateColumbaAccessory,
} from "@/request/view/repair";
import { useStore } from "vuex";
import { Toast, uploadMedia } from "@/utils/index";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";
import { getshowAccessoryByReq } from "../serve/getReqAccessory";
import accessory from "./accessory.vue";
import afterSaleQeustionVue from "./afterSaleQeustion.vue";

export default defineComponent({
  components: {
    accessory,
    afterSaleQeustionVue,
    uploadImgVue,
    uploadVideoVue,
  },
  setup(props, context) {
    const formRef = ref();
    const store = useStore();
    // 模态框
    const modalConfig = reactive({
      title: "新增返修设备",
      visible: false,
    });
    // 选择的设备
    const selectSerial = ref([]);
    // 问题组件
    const questionRef = ref();
    // 返修表单
    const formState = reactive({
      id: null,
      year: null,
      serial: null,
      serialType: null,
      afterSaleProblemDescription: null,
      contactPerson: null,
      repairCustomerInfo: null,
      createUserId: store.getters.user.id,
      picture: null,
      video: null,
      notes: null,
      isEditable: null,
      repairProcess: null,
      returnAddress: null,
    });
    const isEditable = computed(() => {
      return formState.repairProcess === null || formState.repairProcess === 0;
    });

    // 标配表单
    const accessoryRef = ref(null);
    // 请求的配件列表转本地回显数据
    const setEchoAccessory = (reqObj) => {
      const list = [];
      Object.keys(reqObj).forEach((key) => {
        list.push({
          searchVal: key,
          val: reqObj[key],
        });
      });
      return list;
    };
    // 设备配置项
    const options = [
      {
        value: "天鸽",
        label: "天鸽",
        children: [
          {
            value: "300",
            label: "300",
          },
          {
            value: "300S",
            label: "300S",
          },
        ],
      },
      {
        value: "天鹅",
        label: "天鹅",
        children: [
          {
            value: "600",
            label: "600",
          },
          {
            value: "600P",
            label: "600P",
          },
        ],
      },
    ];

    const handleSerialChange = (e) => {
      if (selectSerial.value.length === 2) {
        const [machine, type] = e;
        formState.serialType = `${machine}${type}`;
      } else {
        formState.serialType = null;
      }
    };

    // 配件列表
    const accessoryList = reactive([]);

    // 标配确认方法
    const handleAccessoryOk = () => {
      console.log(accessoryRef.value);
      if (!accessoryRef.value) {
        return Toast("warning", "请选择配件", 3);
      }
      accessoryRef.value
        .validateAccessory()
        .then((res) => {
          accessoryList.length = 0;
          const [standardList, optionalList] = res;
          setAccessoryList(standardList);
          if (optionalList) setAccessoryList(optionalList);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    // 校验配件
    const checkAccessory = async () => {
      console.log(accessoryList.length);
      if (accessoryList.length === 0) {
        return Promise.reject("请选择配件");
      }
      return Promise.resolve();
    };

    const rules = reactive({
      year: [
        {
          required: true,
          message: "请输入年度",
          trigger: "blur",
          type: "number",
        },
      ],
      serial: [
        {
          required: true,
          message: "请输入请输入设备号",
          trigger: "blur",
          type: "string",
        },
      ],
      serialType: [
        {
          required: true,
          message: "请选择设备类型",
          trigger: "blur",
          type: "string",
        },
      ],
      afterSaleProblemDescription: [
        {
          required: true,
          message: "请输入售后问题描述",
          trigger: "blur",
        },
      ],
      contactPerson: [
        {
          required: true,
          message: "请输入对接人",
          trigger: "blur",
          type: "string",
        },
      ],
      repairCustomerInfo: [
        {
          required: true,
          message: "请输入返修客户信息",
          trigger: "blur",
          type: "string",
        },
      ],
      returnAddress: [
        {
          required: true,
          message: "请选择返厂地址",
          trigger: "blur",
          type: "string",
        },
      ],
      accessory: [
        {
          required: true,
          validator: checkAccessory,
          trigger: "blur",
        },
      ],
    });

    const setAccessoryList = (list) => {
      list.forEach((item) => {
        if (item.val) {
          accessoryList.push(item);
        }
      });
    };
    // 重置表单
    const resetAccessoryForm = () => {
      accessoryRef.value.resetAccessoryForm();
    };
    const accessoryId = ref(null);
    const customInfoAuthority = ref(true);
    const editForm = (record, authority) => {
      customInfoAuthority.value = authority;
      modalConfig.title = "编辑返修信息";
      modalConfig.visible = true;
      getshowAccessoryByReq(record.serialType, record.id)
        .then((res) => {
          accessoryList.length = 0;
          setAccessoryList(res.findList);
          accessoryId.value = res.id;
        })
        .catch((err) => {
          console.log(err);
        });
      const machine = record.serialType.replace(/[^\u4E00-\u9FA5]/g, "");
      const machineType = record.serialType.replace(/[^a-za-z0-9]/g, "");
      selectSerial.value.length = 0;
      selectSerial.value.push(machine, machineType);
      formState.id = record.id;
      formState.year = Number(record.year);
      formState.serial = record.serial;
      formState.afterSaleProblemDescription =
        record.afterSaleProblemDescription;
      formState.contactPerson = record.contactPerson;
      formState.repairCustomerInfo = record.repairCustomerInfo;
      formState.serialType = record.serialType;
      formState.video = record.video;
      formState.picture = record.picture;
      formState.notes = record.notes;
      formState.isEditable = record.isEditable;
      formState.repairProcess = record.repairProcess;
      formState.createUserId = record.createUserId;
      formState.returnAddress = record.returnAddress;
      nextTick(() => {
        rules.afterSaleProblemDescription[0].validator =
          questionRef.value.checkQuestionList;
      });
    };

    const resetForm = () => {
      // resetAccessoryForm();
      customInfoAuthority.value = true;
      modalConfig.title = "";
      selectSerial.value.length = 0;
      accessoryList.length = 0;
      formState.id = null;
      formState.year = null;
      formState.serial = null;
      formState.afterSaleProblemDescription = null;
      formState.contactPerson = null;
      formState.repairCustomerInfo = null;
      formState.serialType = null;
      formState.createUserId = store.getters.user.id;
      formState.picture = null;
      formState.video = null;
      formState.notes = null;
      formState.isEditable = null;
      formState.repairProcess = null;
      formState.returnAddress = null;
      accessoryId.value = null;
      formRef.value.clearValidate();
      questionRef.value.resetList();
      setTimeout(() => {
        modalConfig.visible = false;
      }, 0);
    };
    // 图片节点
    const uploadImg = ref();
    // 视频节点
    const uploadVideo = ref();
    // 获取问题列表的数据
    const getAfterSaleProblemDescription = () => {
      const list = [];
      questionRef.value.questionList.forEach((item) => {
        list.push({
          value: item.value,
          disabled: true,
        });
      });
      return JSON.stringify(list);
    };
    // 设置请求列表
    const setRequestAccessory = () => {
      let accessoryObj = {};
      accessoryList.forEach((item) => {
        accessoryObj[item.searchVal] = item.val;
      });
      return accessoryObj;
    };

    const handleOk = () => {
      handleAccessoryOk();
      setTimeout(() => {
        formRef.value
          .validate()
          .then(async () => {
            let imgFileUrl = null;
            let videoFileUrl = null;
            // 配件信息
            const accessory = setRequestAccessory();
            if (accessoryId.value === null) {
              formState.columbaAccessory =
                selectSerial.value.indexOf("天鸽") !== -1 ? accessory : null;
              formState.swanAccessory =
                selectSerial.value.indexOf("天鹅") !== -1 ? accessory : null;
            } else {
              const accessoryFn =
                selectSerial.value.indexOf("天鸽") !== -1
                  ? updateColumbaAccessory
                  : updateSwanAccessory;
              const params = Object.assign(accessory, {
                id: accessoryId.value,
              });
              await accessoryFn(params)
                .then((res) => {
                  console.log(res);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            // 售后问题
            const afterSaleProblemDescription =
              getAfterSaleProblemDescription();
            formState.afterSaleProblemDescription = afterSaleProblemDescription;

            // 上传文件
            await uploadMedia(uploadImg, uploadVideo).then((res) => {
              imgFileUrl = JSON.stringify(res[0]);
              videoFileUrl = JSON.stringify(res[1]);
            });

            formState.picture = imgFileUrl;
            formState.video = videoFileUrl;
            saveOrUpdateRepairEquipment(formState).then((res) => {
              resetForm();
              const isAddRepair = modalConfig.title === "编辑返修信息";
              context.emit("updateTable", isAddRepair);
              let type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }, 0);
    };

    const addRepair = (authority) => {
      // customInfoAuthority.value = authority;
      modalConfig.visible = true;
      const date = new Date();
      modalConfig.title = "新增返修信息";
      formState.year = date.getFullYear();
      nextTick(() => {
        rules.afterSaleProblemDescription[0].validator =
          questionRef.value.checkQuestionList;
        console.log(customInfoAuthority.value);
      });
    };
    // 标配模态框
    const accessoryModal = reactive({
      visible: false,
      title: "选择配件",
    });
    // 打开表单
    const handleOpenAccessoryModal = () => {
      if (selectSerial.value.length === 0)
        return Toast("warning", "请选择设备类型", 3);
      accessoryModal.visible = true;
    };

    return {
      formRef,
      editForm,
      modalConfig,
      handleOk,
      formState,
      rules,
      addRepair,
      resetForm,
      options,
      handleSerialChange,
      selectSerial,
      accessoryModal,
      handleAccessoryOk,
      accessoryRef,
      resetAccessoryForm,
      handleOpenAccessoryModal,
      accessoryList,
      uploadImg,
      uploadVideo,
      questionRef,
      isEditable,
      customInfoAuthority,
    };
  },
});
</script>

<style lang="less">
.ant-input[disabled] {
  color: #000;
}
</style>
